export default class Gallery {
  constructor(element) {
    this.element = element;

    this.init();
  }

  init() {
    const io = new IntersectionObserver(observeImage);

    this.element.querySelectorAll('.js-gallery-item').forEach((element) => io.observe(element));

    function observeImage(entries) {
      entries.forEach((element) => {
        if (element.isIntersecting) {
          const img = element.target.querySelector('img');

          if (img.dataset.src === '') {
            element.target.classList.remove('is-loading');
          } else {
            img.src = img.dataset.src;
          }

          img.onload = () => {
            element.target.classList.remove('is-loading');
          };

          io.unobserve(element.target);
        }
      });
    }
  }
}
